(function () {
    'use strict';

    angular.module('product')
        .controller('PackageCreateController', PackageCreateController);

    PackageCreateController.$inject = ['$state', 'packageDataSrvc', 'packageMessagesConst', 'notificationSrvc', '$timeout', 'errorNotificationSrvc'];

    function PackageCreateController($state, packageDataSrvc, packageMessagesConst, notificationSrvc, $timeout, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name: [],
            width: [],
            height: [],
            length: [],
            max_weight: [],
            nonFieldErrors: []
        };

        self.packageData = {
            name: '',
            width: '',
            height: '',
            length: '',
            max_weight: ''
        };

        self.inlineInputFields = [
            {
                prop: 'width',
                type: 'number',
                title: 'Szerokość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            },
            {
                prop: 'height',
                type: 'number',
                title: 'Wysokość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            },
            {
                prop: 'length',
                type: 'number',
                title: 'Długość',
                isRequired: false,
                isDisabled: false,
                minValue: 1,
                onChange: cleanErrors
            }
        ];

        self.createPackage = createPackage;
        self.cleanErrors = cleanErrors;

        function createPackage() {
            packageDataSrvc.create(
                self.packageData
            ).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", packageMessagesConst.add);
                    $state.go('layout.package.list');
                },
                function(response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }
    }
})();
